const button = {
  contained: {
    boxShadow: 'none',
  },
  root: {
    borderRadius: 0,
    fontWeight: 600,
  },
  sizeSmall: {
    padding: '7px 12px',
  },
};

export default button;
